import React from 'react';

const AdressHeader = () => {
  return (
    <div className='flex flex-col w-[75mm] sm_text'>
      <div className='h-[17mm] w_center text-xl'>거래명세서</div>
      <div className='h-[18mm] sm_text page_center nob_border'>
        자화전자(주)
        <br /> 충청북도 청주시 청원구 북이면 충청대로 1217
        <br /> call
      </div>
    </div>
  );
};

export default AdressHeader;
